// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"60":"component---src-pages-contact-us-js","351":"commons","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"60":"a08d863177223eba5e0a","351":"73d8c0be47d1cd8d06eb","678":"9f96742d4cb71026197a","883":"cdddd39995009e9927e5"}[chunkId] + ".js";
};